import { z } from "zod";

export const ZPing = z.object({
  type: z.literal("ping"),
  message: z.string().optional(),
  time: z.number()
});
export type Ping = z.infer<typeof ZPing>;
